// extracted by mini-css-extract-plugin
module.exports = {"input":"PageSignupForm__input__2fEbH","agreement":"PageSignupForm__agreement__Muv1a","checkbox":"PageSignupForm__checkbox__wwGIf"};